import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import AddSale from "./pages/addSale";
import ViewSale from "./pages/viewSale";
import SharePage from "./pages/share_page";
import AddGuidePage from "./pages/addGuide";
import GuideAnalyticsPage from "./pages/GuideAnalyticsPage";
import GuideSalesDetailPage from "./pages/GuideSalesDetailPage";
import ViewGuidesPage from "./pages/viewGuides";
import LoginPage from "./pages/login";
import AddNotePage from "./pages/addNote";
import TeamDashboard from "./pages/teamDash";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import AdminDashboard from "./pages/adminDash";
import UserManage from "./pages/userManage";
import ManageNotes from "./pages/noteManage";
import SiteManagement from "./pages/siteManage";
import AdminSalesOverview from "./pages/adminSalesOverview";
import ChangePassword from "./pages/changePassword";


function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />

      {/* ========== TEAM MEMBER ROUTES (Limited Access) ========== */}
      <Route
        path="/addSale"
        element={
          <RoleProtectedRoute requiredRole="Team">
            <AddSale />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/viewSale"
        element={
          <RoleProtectedRoute requiredRole="Team">
            <ViewSale />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/add-note"
        element={
          <RoleProtectedRoute requiredRole="Team">
            <AddNotePage />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/team-dashboard"
        element={
          <RoleProtectedRoute requiredRole="Team">
            <TeamDashboard />
          </RoleProtectedRoute>
        }
      />

      {/* ========== PUBLIC ROUTES ========== */}
      <Route path="/share/:data" element={<SharePage />} />

      {/* ========== ADMIN ONLY ROUTES ========== */}
      <Route
        path="/home"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <Home />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/add-guide"
        element={
          <ProtectedRoute>
            <AddGuidePage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/guide-analytics"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <GuideAnalyticsPage />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/guide-sales/:guideId"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <GuideSalesDetailPage />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/view-guides"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <ViewGuidesPage />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/manage-users"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <UserManage />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/manage-sites"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <SiteManagement />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/admin-sales-overview"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <AdminSalesOverview />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/manage-notes"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <ManageNotes />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/admin-dashboard"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <AdminDashboard />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/change-password"
        element={
          <RoleProtectedRoute requiredRole="Admin">
            <ChangePassword />
          </RoleProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
